import React from 'react';
import { NavLink } from 'react-router-dom';
import { Menu, X, LayoutDashboard, PlusCircle, LogOut } from 'lucide-react';
import { cn } from '../lib/utils';
import { useAuth } from '../lib/authTypes';

interface SidebarProps {
  isOpen: boolean;
  onClose: () => void;
}

export function Sidebar({ isOpen, onClose }: SidebarProps) {
  const { logout } = useAuth();
  const navItems = [
    { icon: LayoutDashboard, label: 'Overview', to: '/' },
    { icon: PlusCircle, label: 'Create Record', to: '/create' },
  ];

  const handleLogout = () => {
    logout();
  };

  return (
    <>
      {/* Overlay */}
      <div
        className={cn(
          'fixed inset-0 bg-black/50 z-20 lg:hidden transition-opacity',
          isOpen ? 'opacity-100' : 'opacity-0 pointer-events-none'
        )}
        onClick={onClose}
      />

      {/* Sidebar */}
      <aside
        className={cn(
          'fixed top-0 left-0 z-30 h-full w-64 bg-[#121212] text-white transform transition-transform duration-200 ease-in-out lg:translate-x-0 lg:relative flex flex-col',
          isOpen ? 'translate-x-0' : '-translate-x-full'
        )}
      >
        <div className="p-4 flex justify-between items-center lg:hidden">
          <span className="text-xl font-bold">Dashboard</span>
          <button onClick={onClose} className="p-2">
            <X className="h-6 w-6" />
          </button>
        </div>

        <nav className="p-4 flex-1">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) =>
                cn(
                  'flex items-center gap-3 px-4 py-3 rounded-lg transition-colors',
                  'hover:bg-[#282828]',
                  isActive ? 'bg-[#282828]' : 'text-gray-400'
                )
              }
              onClick={() => onClose()}
            >
              <item.icon className="h-5 w-5" />
              <span>{item.label}</span>
            </NavLink>
          ))}
        </nav>

        <div className="p-4 border-t border-white/10">
          <button
            onClick={handleLogout}
            className="flex items-center gap-3 px-4 py-3 rounded-lg transition-colors text-gray-400 hover:bg-[#282828] w-full"
          >
            <LogOut className="h-5 w-5" />
            <span>Logout</span>
          </button>
        </div>
      </aside>
    </>
  );
}

export function MobileHeader({ onOpenSidebar }: { onOpenSidebar: () => void }) {
  return (
    <header className="lg:hidden flex items-center justify-between p-4 bg-[#121212] text-white">
      <button onClick={onOpenSidebar} className="p-2">
        <Menu className="h-6 w-6" />
      </button>
      <span className="text-xl font-bold">Dashboard</span>
    </header>
  );
}